var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wallet"},[_c('h1',[_vm._v(_vm._s(_vm.$t("wallet.title")))]),_c('div',{staticClass:"d-flex align-center justify-center height100"},[_c('div',{staticClass:"text-h5"},[_vm._v(_vm._s(_vm.$t("wallet.description")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }